// extracted by mini-css-extract-plugin
export default {"footer_popup_container":"FooterPoup_footer_popup_container__rT1k3"};